import styles from './styles';

import { CobliLogo, Heading1, Heading2 } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

export const LOW_RESOLUTION_COOKIE_NAME = 'continue_with_low_resolution';

interface LowResolutionPlaceholderProps {
  onContinue: () => void;
}

function LowResolutionPlaceholder({
  onContinue,
}: LowResolutionPlaceholderProps) {
  return (
    <div className={styles.lowResolutionPlaceholder}>
      <CobliLogo />
      <Heading1>
        O sistema funciona melhor em resoluções de tela maior.
      </Heading1>
      <Heading2>O aplicativo estará disponível em breve.</Heading2>
      <Button onClick={onContinue}>Continuar</Button>
    </div>
  );
}

export default LowResolutionPlaceholder;
